/*
 * AUTO OBRAZY — analytics bridge.
 *
 * V49: previously every event was silently discarded because the code only
 * pushed to window.dataLayer when it already existed, and no GTM/GA4/Pixel was
 * ever loaded. Now the queue is always created, events are mirrored to gtag
 * and fbq when they are present, and standard e-commerce events are emitted
 * alongside the internal ao_* ones so any tag manager can consume them.
 */
(function () {
  'use strict';
  if (window.AOAnalytics) return;

  // Always create the queue. Tag managers loaded later will replay it.
  window.dataLayer = window.dataLayer || [];

  var MAX_QUEUE = 400;

  // Internal event name -> standard e-commerce event name.
  var STANDARD_EVENTS = {
    shirt_add_to_cart_attempt: 'add_to_cart',
    quick_add_to_cart: 'add_to_cart',
    /* V253: „attempt" aj „success" sa obidva prekladali na add_to_cart, takže
       jedno pridanie obrazu do košíka poslalo do GA4 aj do Meta Pixelu DVA
       AddToCart eventy. Kampaň sa potom optimalizuje na číslo, ktoré je
       dvojnásobkom skutočnosti, a pomer AddToCart → Purchase klame.
       Štandardný event patrí len k úspešnému pridaniu; pokus ostáva
       v dataLayer ako ao_vehicle_add_to_cart_attempt na ladenie. */
    vehicle_add_to_cart_success: 'add_to_cart',
    product_view: 'view_item',
    collection_view: 'view_item_list',
    search_performed: 'search',
    search_zero_results: 'search_no_results',
    begin_checkout: 'begin_checkout',
    cart_view: 'view_cart'
  };

  function clean(value, depth) {
    if (depth > 3) return undefined;
    if (value == null || typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') return value;
    if (Array.isArray(value)) return value.slice(0, 20).map(function (item) { return clean(item, depth + 1); });
    if (typeof value === 'object') {
      var out = {};
      Object.keys(value).slice(0, 30).forEach(function (key) {
        var normalized = clean(value[key], depth + 1);
        if (normalized !== undefined) out[key] = normalized;
      });
      return out;
    }
    return String(value);
  }

  function push(record) {
    try {
      if (window.dataLayer.length > MAX_QUEUE) window.dataLayer.splice(0, 50);
      window.dataLayer.push(record);
    } catch (error) { /* never break the page for analytics */ }
  }

  function track(name, detail) {
    var eventName = String(name || '').trim().replace(/[^a-zA-Z0-9_:-]/g, '_');
    if (!eventName) return;

    var payload = clean(detail || {}, 0) || {};

    // 1. Internal namespaced event — useful for debugging and custom triggers.
    push(Object.assign({ event: 'ao_' + eventName }, payload));

    // 2. Standard e-commerce alias so GA4 / GTM templates work out of the box.
    var standard = STANDARD_EVENTS[eventName];
    if (standard) push(Object.assign({ event: standard }, payload));

    // 3. Mirror to gtag / Meta Pixel when the merchant has them installed.
    try {
      if (standard && typeof window.gtag === 'function') window.gtag('event', standard, payload);
    } catch (error) {}
    try {
      if (typeof window.fbq === 'function') {
        if (standard === 'add_to_cart') window.fbq('track', 'AddToCart', payload);
        else if (standard === 'view_item') window.fbq('track', 'ViewContent', payload);
        else if (standard === 'search') window.fbq('track', 'Search', payload);
        else if (standard === 'begin_checkout') window.fbq('track', 'InitiateCheckout', payload);
      }
    } catch (error) {}

    // 4. DOM event so other theme scripts can listen without coupling.
    try {
      document.dispatchEvent(new CustomEvent('ao:analytics', {
        detail: { name: eventName, data: payload }
      }));
    } catch (error) {}
  }

  window.AOAnalytics = Object.freeze({ track: track });

  /* ---------- declarative click tracking ---------- */
  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target.closest('[data-ao-track]') : null;
    if (!target) return;
    track(target.dataset.aoTrack, {
      label: target.dataset.aoTrackLabel || (target.textContent || '').trim().slice(0, 120),
      href: target.getAttribute('href') || '',
      product_id: target.dataset.aoTrackProductId || target.dataset.productId || '',
      value: target.dataset.aoTrackValue || '',
      currency: target.dataset.aoTrackCurrency || ''
    });
  }, { passive: true });

  /* ---------- automatic page-level events ---------- */
  function boot() {
    var main = document.getElementById('MainContent');
    var template = (main && main.dataset.template) || '';
    var context = window.AOPageContext || null;

    if (/^product/.test(template) && context && context.product) {
      track('product_view', {
        items: [{
          item_id: context.product.id,
          item_name: context.product.title,
          item_variant: context.product.variant_title || '',
          price: context.product.price,
          currency: context.currency || 'EUR'
        }],
        value: context.product.price,
        currency: context.currency || 'EUR'
      });
    } else if (/^collection|^list-collections/.test(template) && context) {
      track('collection_view', { item_list_name: context.collectionTitle || '', items_count: context.collectionCount || 0 });
    } else if (/^cart/.test(template) && context) {
      track('cart_view', { value: context.cartTotal || 0, currency: context.currency || 'EUR', items_count: context.cartCount || 0 });
    } else if (/^search/.test(template)) {
      var params = new URLSearchParams(window.location.search);
      var term = params.get('aoq') || params.get('q') || '';
      if (term) {
        var resultCount = context && typeof context.searchResults === 'number' ? context.searchResults : null;
        track(resultCount === 0 ? 'search_zero_results' : 'search_performed', {
          search_term: term,
          results: resultCount
        });
      }
    }

    // Checkout intent from any cart form or drawer button.
    document.addEventListener('click', function (event) {
      var el = event.target && event.target.closest
        ? event.target.closest('[name="checkout"], .ao-cart-checkout, [data-ao-checkout]')
        : null;
      if (!el) return;
      var ctx = window.AOPageContext || {};
      track('begin_checkout', { value: ctx.cartTotal || 0, currency: ctx.currency || 'EUR', items_count: ctx.cartCount || 0 });
    }, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
